export default __webpack_public_path__ + "static/media/about-3.e23b57fc.png";